export enum SetPasswordModes {
  Register = 'Register',
  Recover = 'Recover',
}
